import React from "react";
import DocumentTitle from "./DocumentTitle";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DocumentSegment = function DocumentSegment(_ref) {
  var title = _ref.title,
    children = _ref.children,
    left = _ref.left;
  return /*#__PURE__*/_jsxs("div", {
    className: "mt-4 first:mt-0",
    children: [/*#__PURE__*/_jsx(DocumentTitle, {
      left: left,
      children: title
    }), children]
  });
};
export default DocumentSegment;
//# sourceMappingURL=DocumentSegment.js.map